<template>
  <v-row>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card>
        <v-card-title>
          Home
        </v-card-title>
        <v-card-text>
          Latest image of GOES-East
        </v-card-text>
        <v-container fluid>
          <v-row justify="center">
            <img
              src="https://cdn.star.nesdis.noaa.gov/GOES16/ABI/SECTOR/car/GEOCOLOR/2000x2000.jpg"
              style="margin:-7px 0px 0px 0px;width:100%"
            />
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({})
};
</script>
